import { Box, makeStyles, Typography } from "@material-ui/core";
import { PermissionedUser } from "./PermissionedUser";
import { User } from "../../../domain/User";
import { Warning } from "@material-ui/icons";

type PermissionsListProps = {
  ownerUpn: string | undefined;
  permissions: string[];
  users: User[];
  visibleToAllStaff: boolean;
  onDelete: (userId: string) => void;
};

const useStyles = makeStyles((theme) => ({
  iconSection: {
    padding: 10,
  },
  icon: {
    fontSize: "6rem",
    color: theme.palette.grey[400],
    marginRight: 20,
  },
  allStaffMessage: {
    borderWidth: 1,
    borderStyle: "dashed",
    borderColor: theme.palette.grey[400],

    padding: 15,
    height: "9rem",
    alignSelf: "center",
    borderRadius: 5,
  },
}));

export const PermissionsList: React.FC<PermissionsListProps> = ({
  ownerUpn,
  permissions,
  users,
  visibleToAllStaff,
  onDelete,
}) => {
  const classes = useStyles();
  const getUser = (upn: string | undefined) =>
    (upn && users.find((user) => user.upn === upn)) || null;

  const ownerUser = getUser(ownerUpn);
  return (
    <Box display="flex" flexWrap="wrap">
      {ownerUser && <PermissionedUser user={ownerUser} isOwner />}

      {!visibleToAllStaff &&
        permissions
          .map((upn) => getUser(upn))
          .filter((user) => !!user)
          .sort((a, b) => (a!.id > b!.id ? 1 : -1))
          .map((user) => (
            <PermissionedUser user={user!} onDelete={onDelete} key={user!.id} />
          ))}
      {visibleToAllStaff && (
        <Box
          display="flex"
          alignItems="center"
          flexGrow={1}
          className={classes.allStaffMessage}
        >
          <div>
            <Warning className={classes.icon} />
          </div>
          <Typography variant="body1">
            <b>All Ofqual staff can view this record</b>
          </Typography>
        </Box>
      )}
    </Box>
  );
};
